import { makeAutoObservable, runInAction } from 'mobx'
import { message } from 'antd'
import i from '../../translations/i'
import { parseProject } from '../../helpers/project.controller'
import { openApi } from '../../helpers/request'

class dashboardController {

    statisticOrder: any = []
    statisticOrderDates?: string[] = []

    project = {
        urlios: '',
        urlandroid: '',
        url_app_gallery: '',
        url_ru_store: '',
        name: '',
        bandl: '',
        datepayend: 0,
    }

    /** Подписка из /billing/status; null — ещё не пришла или раздел оплаты на сервере не развёрнут */
    billing: { available: boolean, subscription: any } | null = null
    billingLoaded: boolean = false

    stat = {
        products: 0,
        categories: 0,
        orders: 0,
        users: 0,
        best: {
            products_cart: [],
            products_order: [],
        }
    }

    constructor() {
        makeAutoObservable(this)
    }

    setStatisticOrderDates(dates: string[]) {
        this.statisticOrderDates = dates
        this.ordersStatistic()
    }

    getStat() {
        openApi('get', '/stat')
            .then(result => {
                console.log(result)
                runInAction(() => this.stat = result.data)
            })
          .catch(err => console.log(err.response))
    }

    getBillingStatus() {
        openApi('get', '/billing/status', {}, undefined, true)
            .then(result => runInAction(() => this.billing = result.data))
            .catch(() => runInAction(() => this.billing = null))
            .finally(() => runInAction(() => this.billingLoaded = true))
    }

    copyLink(link: string) {
        navigator.clipboard.writeText(link)
            .then(result => message.success(i.t('dashboard:links.copy')))
            .catch(err => message.success(i.t('dashboard:links.copyError')))
    }

    async getProject() {
        const project = await parseProject()
        if(project) {
            console.log(project)
            runInAction(() => this.project = project)
        }
    }

    ordersStatistic() {
        let uri = '/statistic'
        if(this.statisticOrderDates && this.statisticOrderDates.length > 0)
            uri = `${uri}?date_from=${this.statisticOrderDates[0]}&date_to=${this.statisticOrderDates[1]}`

        openApi('get', uri)
            .then(result => {
                console.log(result)
                let array: any = []
                Object.keys(result).map((el: string) => array.push({
                    name: el,
                    full_count: result[el].full_count,
                    sum: result[el].sum,
                    count_not_payed: result[el].count_not_payed,
                    count_payed: result[el].count_payed,
                }))

                this.statisticOrder = array
            })
            .catch(error => console.log(error.response.data.message))
    }

    getBestSellers() {}

}

export default new dashboardController()